import React from "react";
import { Link } from "react-router-dom";

export default function Post({ post }) {
  const { id, title, image, isSaved, tags, createdAt, likes } = post;
  return (
    <>
      <div className="lws-card">
        <Link to={`/post/${id}`}>
          <img src={image} className="lws-card-image" alt="" />
        </Link>
        <div className="p-4">
          <div className="lws-card-header">
            <p className="lws-publishedDate">{createdAt}</p>
            <p className="lws-likeCount">
              <i className="fa-regular fa-thumbs-up"></i>
              {likes}
            </p>
          </div>
          <Link to={`/post/${id}`} className="lws-postTitle">
            {" "}
            {title}{" "}
          </Link>
          <div className="lws-tags">
            {tags.map((tag, index) => {
              const comma = index < tags.length - 1 ? ", " : "";
              return (
                <span key={index}>
                  #{tag}
                  {comma}
                </span>
              );
            })}
          </div>
          {isSaved && (
            <div className="flex gap-2 mt-4">
              <span className="lws-badge"> Saved </span>
            </div>
          )}
        </div>
      </div>
      {/* <!-- Single Post Ends --> */}
    </>
  );
}
